const STEPS = [
  { n: '01', title: 'Talaby al' },
  { n: '02', title: 'Senariýa düz' },
  { n: '03', title: 'Hasapla' },
  { n: '04', title: 'Müşderä iber' },
  { n: '05', title: 'Tassykla & ugrat' },
]

export function HowItWorks() {
  return (
    <section id="how" className="border-b border-border">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-16 lg:py-24">
        <div className="max-w-2xl mb-10">
          <p className="eyebrow text-primary mb-3">Iş akymy</p>
          <h2 className="text-[28px] sm:text-[36px] leading-tight font-semibold tracking-tight">
            Talapdan ugratmaga bäş ädim.
          </h2>
        </div>

        <ol className="grid grid-cols-2 md:grid-cols-5 gap-px bg-border rounded-2xl overflow-hidden border border-border">
          {STEPS.map((s) => (
            <li key={s.n} className="bg-background p-5">
              <div className="font-mono text-[12px] text-primary mb-2 tracking-wider">
                {s.n}
              </div>
              <h3 className="text-[15px] font-semibold tracking-tight leading-snug">
                {s.title}
              </h3>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}
